import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Navigation from "../../../components/Navigation";
import Y_Us_StripComponent from "../../common/Y_us_strip";
import SecNav from "../../../components/SecNav";

const AboutUs = () => {
  return (
    <div className="container">
      <Navigation />
      <SecNav
        title={"About Us"}
        body={
          "Welcome to BestEmbroidery! By accessing or using our website, you agree to comply with and be bound by the following terms & services. Please read these terms carefully before using our platform."
        }
      />

      <div className="row fs-18 mt-5 mx-auto justify-content-between ">
        <div className="col-lg-7">
          <p>
            By using BestEmbroidery, you confirm that you are at least 18 years
            old or have the consent of a legal guardian to use this website.
            Your continued use of the site constitutes your acceptance of these
            terms and any future updates.All content on BestEmbroidery,
            including designs, logos, text, and images, is the property of
            BestEmbroidery or its licensors and is protected by copyright and
            intellectual property laws. You may not reproduce, distribute, or
            use any content without prior written permission.
          </p>
          <p className="mt-4">
            BestEmbroidery is not liable for any indirect, incidental, or
            consequential damages arising from the use of our website or
            products. Our total liability for any claim related to our services
            shall not exceed the amount paid for the product in question.
          </p>
          <p className="mt-4">
            {" "}
            By using BestEmbroidery, you confirm that you are at least 18 years
            old or have the consent of a legal guardian to use this website.
            Your continued use of the site constitutes your acceptance of these
            terms and any future updates. All content on BestEmbroidery,
            including designs, logos, text, and images, is the property of
            BestEmbroidery or its licensors and is protected by copyright and
            intellectual property laws. You may not reproduce, distribute, or
            use any content without prior written permission. BestEmbroidery is
            not liable for any indirect, incidental, or consequential damages
            arising from the use of our website or products. Our total liability
            for any claim related to our services shall not exceed the amount
            paid for the product in question.
          </p>
        </div>
        <div className="col-lg-5 d-flex justify-content-center align-items-center">
          <img loading="lazy" 
            src="/bannerr.png"
            alt="BestEmbroidery"
            className="img-fluid h-100 w-100 object-fit-cover rounded-4 shadow"
          />
        </div>
      </div>

      <div className="row fs-18 mt-2 mx-auto ">
        <div className="col-12">
          <div>
            <p>
              BestEmbroidery is not liable for any indirect, incidental, or
              consequential damages arising from the use of our website or
              products. Our total liability for any claim related to our
              services shall not exceed the amount paid for the product in
              question. nsors and is protected by copyright and intellectual
              property laws. You may not reproduce, distribute, or use any
              content without prior written permission. BestEmbroidery is not
              liable for any indirect, incidental, or consequential damages
              arising from the use of our website or products. Our total
              liability for any claim related to our services shall not exceed
              the amount paid for the product in question.
            </p>

            <p>
              By using BestEmbroidery, you confirm that you are at least 18
              years old or have the consent of a legal guardian to use this
              website. Your continued use of the site constitutes your
              acceptance of these terms and any future updates. All content on
              BestEmbroidery, including designs, logos, text, and images, is the
              property of BestEmbroidery or its licensors and is protected by
              copyright and intellectual property laws. You may not reproduce,
              distribute, or use any content without prior written permission.
              BestEmbroidery is not liable for any indirect, incidental, or
              consequential damages arising from the use of our website or
              products. Our total liability for any claim related to our
              services shall not exceed the amount paid for the product in
              question.
            </p>

            <p>
              BestEmbroidery is not liable for any indirect, incidental, or
              consequential damages arising from the use of our website or
              products. Our total liability for any claim related to our
              services shall not exceed the amount paid for the product in
              question. nsors and is protected by copyright and intellectual
              property laws. You may not reproduce, distribute, or use any
              content without prior written permission. BestEmbroidery is not
              liable for any indirect, incidental, or consequential damages
              arising from the use of our website or products. Our total
              liability for any claim related to our services shall not exceed
              the amount paid for the product in question.
            </p>
          </div>
        </div>
      </div>

      <div className="">
        <Y_Us_StripComponent />
      </div>
    </div>
  );
};

export default AboutUs;
